export default __webpack_public_path__ + "static/inbox-2a4b85a64d5a954ee2245738205de61a.wav";